

import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VoceCorrelataClassificaDTO } from "@app/shared/dto/voce-correlata-classificaDTO";
import { VoceCorrelataClassificaVO } from "@app/shared/vo/voce-correlata-classificaVO";


@Injectable({
    providedIn: 'root'
})
export class MapperVoceCorrelataClassifica implements MapperInterface<VoceCorrelataClassificaDTO, VoceCorrelataClassificaVO> {

    convertVoToDto(vo: VoceCorrelataClassificaVO): VoceCorrelataClassificaDTO {
        if (vo != null) {
            const dto = new VoceCorrelataClassificaDTO();
            // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
            dto.codice = vo.codice;
            dto.nome = vo.nome;
            dto.motivo = vo.motivo;
            dto.nota = vo.nota;
            return dto;
        } else {
            return null;
        }
    }

    convertDtoToVo(dto: VoceCorrelataClassificaDTO): VoceCorrelataClassificaVO {
        if (dto != null) {
            const vo = new VoceCorrelataClassificaVO();
            // TODO fare mapper questa riga funge solo se DTO e VO sono identici
            // vo = JSON.parse(JSON.stringify(dto));
            vo.codice = dto.codice;
            vo.nome = dto.nome;
            vo.motivo = dto.motivo;
            vo.nota = dto.nota;
            vo.output = dto.codice + " - " + dto.nome
            return vo; 
        } else {
            return null;
        }
    }

    convertListVoToDto(voList: VoceCorrelataClassificaVO[]): VoceCorrelataClassificaDTO[] {
        if (voList != null) {
            return voList.map(vo => this.convertVoToDto(vo));
        } else {
            return null;
        }
    }

    convertListDtoToVo(dtoList: VoceCorrelataClassificaDTO[]): VoceCorrelataClassificaVO[] {
        if (dtoList != null) {
            return dtoList.map(dto => this.convertDtoToVo(dto));
        } else {
            return null;
        }
    }
}
